export const sumObjectsNumbers = (obj: object) => {
  let sum = 0;
  for (const key in obj) {
    if (obj) {
      sum += obj[key];
    }
  }
  return sum;
};
